module.exports = __webpack_public_path__ + "img/SLSGTDetailed-min.921c3100.png";